// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.
// @ts-ignore
import { AuthReactConfig } from '@asgardeo/auth-react';

// ------------ Applicable only for WSO2 org transition period-----------
// UNCOMMENT AND USE THIS FOR WSO2 HOSTED DEPLOYMENT

declare global {
  interface Window {
    config: {
      ASGARDEO_BASE_URL: string;
      ASGARDEO_CLIENT_ID: string;
      AUTH_SIGN_IN_REDIRECT_URL: string;
      AUTH_SIGN_OUT_REDIRECT_URL: string;
      CERTIFICATION_SERVICE_API_URL: string;
    };
  }
}

export const AsgardioConfig: AuthReactConfig = {
  signInRedirectURL: window.config?.AUTH_SIGN_IN_REDIRECT_URL ?? "",
  signOutRedirectURL: window.config?.AUTH_SIGN_OUT_REDIRECT_URL ?? "",
  clientID: window.config?.ASGARDEO_CLIENT_ID ?? "",
  baseUrl: window.config?.ASGARDEO_BASE_URL ?? "",
  scope: ["openid", "email", "groups"],
  periodicTokenRefresh: true
};
export const ServiceBaseUrl =
  window.config?.CERTIFICATION_SERVICE_API_URL ?? "";

export const AppBaseUrl = window.config?.AUTH_SIGN_IN_REDIRECT_URL ?? "";
export const CertificationServiceApiUrl =
  window.config?.CERTIFICATION_SERVICE_API_URL ?? "";
export const LinkedinBaseUrl = "https://www.linkedin.com/profile/add";

// ----------------- Use below code for digitaloperationsuser related deployments----------------------------
// UNCOMMENT AND USE THIS FOR LOCAL DEVELOPMENT WITH .env FILE

// export const AsgardioConfig: BaseURLAuthClientConfig = {
//   signInRedirectURL: `${process.env.REACT_APP_AUTH_SIGN_IN_REDIRECT_URL}`,
//   signOutRedirectURL: `${process.env.REACT_APP_AUTH_SIGN_OUT_REDIRECT_URL}`,
//   clientID: `${process.env.REACT_APP_ASGARDEO_CLIENT_ID}`,
//   baseUrl: `${process.env.REACT_APP_ASGARDEO_BASE_URL}`,
//   scope: ["openid", "profile", "email"],
// };
// export const AppBaseUrl = `${process.env.REACT_APP_AUTH_SIGN_IN_REDIRECT_URL}`;
// export const CertificationServiceApiUrl = `${process.env.REACT_APP_CERTIFICATION_SERVICE_API_URL}`;
// export const LinkedinBaseUrl = "https://www.linkedin.com/profile/add";

// ------------------------------- DO NOT CHANGE BELOW THIS LINE -------------------------------
export const AppConfig = {
  serviceUrls: {
    getAppStatus: `${CertificationServiceApiUrl}/app-status`,
    getAdminConfigs: `${CertificationServiceApiUrl}/admin-configs`,
    getAllRegisteredExams: `${CertificationServiceApiUrl}/contacts`,
    getContact: `${CertificationServiceApiUrl}/contacts`,
    getAllAwardedCertifications: `${CertificationServiceApiUrl}/user-certifications`,
    getAwards: `${CertificationServiceApiUrl}/awards`,
    getAllCertifications: `${CertificationServiceApiUrl}/all-user-certifications`,
    getCertificationStats: `${CertificationServiceApiUrl}/certification-stats`,
    getExam: `${CertificationServiceApiUrl}/exams`,
    submitFeedback: `${CertificationServiceApiUrl}/user-feedback`,

    getExamPaper: `${CertificationServiceApiUrl}/exam-papers`,
    saveExamPaper: `${CertificationServiceApiUrl}/answers`,
    submitExamPaper: `${CertificationServiceApiUrl}/answers/submit`,
    finishPracticalExam: `${CertificationServiceApiUrl}/exams`,
    getLeaderboard: `${CertificationServiceApiUrl}/leaderboard`,
  },
};
